import React from 'react'
import brandLogo from '../../../assets/images/brandlogo.png'
import demoLogo from '../../../assets/images/demologo.png'
import parentheaderStyle from './ParentsHeader.module.css'
import { Dropdown, Button, Divider, SelectPicker } from 'rsuite';
import { FaShoppingCart } from 'react-icons/fa';
import TrashIcon from '@rsuite/icons/Trash';
import 'rsuite/dist/rsuite.min.css';
require('typeface-poppins')


export default function ParentsHeader() {

  const qtyOptions = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 }
  ];

  return (
    <>
      <header className={parentheaderStyle.pmHeader}>
        <div className={parentheaderStyle.pmheaderContent}>
          <div className='container'>
            <nav className={`${parentheaderStyle.pmnav} ${parentheaderStyle.pmnavExpand} flex-wrap`}>
              <a href="/" className={`${parentheaderStyle.pmheaderLeft} me-auto`}>
                <div className={`${parentheaderStyle.pmheaderBrand} d-flex align-items-center`}>
                  <img src={brandLogo} className="img-fluid" />
                  <div className={parentheaderStyle.pmbrandTitles}>
                    <h6> AuthorMeet </h6>
                    <p> Powered by: Bookworm Central </p>
                  </div>
                </div>
              </a>
              <div className={parentheaderStyle.pmheaderRight}>
                <div className={`${parentheaderStyle.pmheaderbrandRight} d-flex align-items-center`}>
                  <div className={parentheaderStyle.pmbrandRightIcon}>
                    <img src={demoLogo} className="img-fluid" />
                  </div>
                  <div className={`${parentheaderStyle.pmTitleRight} me-3`}>
                    <h6>Author User Name</h6>
                  </div>
                  <Dropdown trigger="click" placement="bottomEnd" renderToggle={(props, ref) => (<Button {...props} ref={ref} appearance="subtle">
                    <FaShoppingCart className='me-2' /> Cart </Button>)}>
                    <div style={{ width: 350, background: '#fff', padding: 16 }} onClick={e => e.stopPropagation()}>
                      <div className={parentheaderStyle.carttitle}>
                        Your Shopping Cart
                      </div>
                      <div className={parentheaderStyle.bookcartbox}>
                        <img src="https://via.placeholder.com/60" width={81} alt="product" />
                        <div style={{ flex: 1 }}>
                          <div className={parentheaderStyle.booktitle}>
                            Big Dog and Little Dog: Going for a Walk
                          </div>
                          <div className={parentheaderStyle.booktitletwo}>
                            Hard Cover
                          </div>
                          <SelectPicker data={qtyOptions} defaultValue={1} searchable={false} cleanable={false} style={{ width: 80, marginTop: 6 }} />
                        </div>
                        <TrashIcon style={{ color: 'red', cursor: 'pointer', marginTop: 5 }} />
                      </div>
                      <div className={parentheaderStyle.subtotlbox} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className={parentheaderStyle.subtotlamt}>Subtotal</span>
                        <span className={parentheaderStyle.subtotlamt}>$0.00</span>
                      </div>
                      <div className={parentheaderStyle.totlbox} style={{ display: 'flex', justifyContent: 'space-between', }} >
                        <span className={parentheaderStyle.totlamt}>Total</span>
                        <span className={parentheaderStyle.totlamt}>$0.00</span>
                      </div>
                      <Button className={parentheaderStyle.checkoubutton}> Checkout </Button>
                      <Button className={parentheaderStyle.contibutton}>Continue Shopping</Button>
                    </div>
                  </Dropdown>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  )
}
